module.exports = __webpack_public_path__ + "static/media/Colette Wing Single Headboard - 120 cm_Brown.727ab2a0.png";